import { getEmptyOperandModalState } from './OperandModal.Helpers';
import { Unsubscribe } from 'redux';
import actions from '../../../../store/actions';
import Lookup from '../../../../types/functions/Lookup';
import Modal from '../../../Common/Modal/Modal';
import Operand from '../../../../types/functions/Operand/Operand';
import OperandBuilder from '../OperandBuilder';
import OperandModalState from './OperandModalState';
import React from 'react';
import ReportCollections from '../../../../infrastructure/types/Functions/ReportCollections';
import ReportVariable from '../../../../types/report/ReportVariable';
import SpecialScenario from '../Props/SpecialScenario';
import store from '../../../../store/store';
import Selector from '../../../../types/report/Selector';
import Dictionary from '../../../../types/report/Dictionary';
import UserDefinedFunction from '../../../../types/report/UserDefinedFunction';
import operandType from '../../../../infrastructure/constants/functions/operandType';
import './styles.scss';
import ReportCase from '../../../../types/report/ReportCase';
import Aggregation from '../../../../types/report/Aggregation';

interface OperandModalProps {
    collections: ReportCollections;
    userDefinedFunctions: UserDefinedFunction[];
    dictionaries: Dictionary[];
    lookups: Lookup[];
    variables: ReportVariable[];
    cases: ReportCase[],
    aggregations: Aggregation[],
    isinSelectors: Selector[],
    leiSelectors: Selector[],
    exchangeRatesSelectors: Selector[],
    onChange?: (operand: Operand) => Promise<boolean>;
    reportType: string;
    regime: string;
}

class OperandModal extends React.Component<OperandModalProps, OperandModalState> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: OperandModalProps) {
        super(props);

        this.state = getEmptyOperandModalState();

        this.onStateChange = this.onStateChange.bind(this);
        this.onOperandChange = this.onOperandChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.onStateChange);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    onStateChange(): void {

        let state = store.getState();
        if (state.action !== actions.operandModal.change) {
            return;
        }

        let operandTypeInState = state.operandModalChange.operand?.operandType ?
            state.operandModalChange.operand.operandType :
            state.operandModalSave.operand.operandType;

        let isOperandType = Object.keys(operandType).map(x => x.toLowerCase()).includes(operandTypeInState.toLowerCase());

        if (!isOperandType && !state.operandModalChange.operand?.value && state.operandModalChange.arrayItemLegitimacy) {

            state.operandModalChange.operand.operandType = operandType.arrayItem;
            state.operandModalChange.operand.dataType = state.operandModalChange.arrayItemLegitimacy.itemDataType as string;
        }

        this.setState(state.operandModalChange);
    }

    async onOperandChange(changes: Operand, specialScenario?: SpecialScenario): Promise<void> {

        let proceed = true;
        if (this.props.onChange) {
            proceed = await this.props.onChange(changes);
        }

        if (proceed) {
            let state = { error: null } as OperandModalState;


            state.operand = Object.assign({}, this.state.operand, changes);

            state.specialScenario = {

                doNotPopulate: Boolean(specialScenario?.doNotPopulate),

                pseudoFunction: specialScenario?.pseudoFunction || null
            };

            this.setState(state);
        }
    }

    onSaveClick(): void {
        store.dispatch({ type: actions.operandModal.save, payload: this.state });
        store.dispatch({ type: actions.component.change, payload: { location: this.state.location } });
    }

    close(): void {
        this.setState({ isOpen: false });
    }

    render(): JSX.Element {
        return (
            <Modal
                state={this.state}
                close={this.close}
                modalContentClasses='width-610px'
            >

                <OperandBuilder
                    regime={this.props.regime}
                    reportType={this.props.reportType}
                    operand={this.state.operand}
                    onOperandChange={this.onOperandChange}
                    operandRules={this.state.operandRules}
                    collections={this.props.collections}
                    location={this.state.location}
                    userDefinedFunctions={this.props.userDefinedFunctions}
                    dictionaries={this.props.dictionaries}
                    lookups={this.props.lookups}
                    cases={this.props.cases}
                    aggregations={this.props.aggregations}
                    variables={this.props.variables}
                    dataSource1Id={this.state.dataSource1Id}
                    dataSource2Id={this.state.dataSource2Id}
                    customDataSourceLegitimacy={this.state.customDataSourceLegitimacy}
                    specialScenario={this.state.specialScenario}
                    customDataSourceContext={this.state.customDataSourceContext}
                    isinSelectors={this.props.isinSelectors}
                    leiSelectors={this.props.leiSelectors}
                    exchangeRatesSelectors={this.props.exchangeRatesSelectors}
                    arrayItemLegitimacy={this.state.arrayItemLegitimacy}
                    functionParameters={this.state.parameters}
                />

                <div className="mt-3 mb-3">
                    <button className="btn cb-btn" onClick={this.onSaveClick}>Save</button>
                </div>
            </Modal>
        );
    }
}

export default OperandModal;